import { BASE_ENDPOINT } from "../../../endpoint";

export const downloadAllVaultTransactionService = async (
	token: string,
	filters: { [key: string]: string },
) => {
	const queryParams = new URLSearchParams(filters).toString();
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/user/tellermanagement/all/vault/download?${queryParams}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					Accept: "application/pdf",
				},
			},
		);
		return response;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
